//Этот компонент выводит карточку-кликер (карточка-таб) для дальнейшего использования в приложении!
//Нажатие на карточку должно перехватываться с верхнего уровня (где рендерится этот компонент) и отрисовывать нужную инфо с правой стороны экрана!
//Компонент содержит title, style(который может передаваться кастомно сверху), иконку(в виде стрелочки) и необязательные дополнительные атрибуты (ReactNode)!

import { ArrowRightOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { Tag } from "antd";
import React, { MouseEvent, useState } from "react";
import { UI_ModuleTitleCardProps } from "../../interfaces/props/UI_ModuleTitleCardProps";
import { UI_ITOTooltip } from "../indexUI";

import classes from "./style/UI_ITOModuleTitleCard.module.css";

// заголовок карточки
export function UI_ModuleTitleCard(props: UI_ModuleTitleCardProps) {
  const {
    className = "",
    title,
    style,
    iconAdditional,
    icon,
    textDown,
    onClick,
    isArchive,
    isActive = false,
    status,
  } = props;
  const [isTooltipVisible, setTooltipVisible] = useState(false);

  function toogleStyle() {
    return `${className} ${classes.cardWrapper} ${
      isArchive !== undefined ? classes.cardWrapper_isArchive : ""
    } ${isActive ? classes.active : ""}`;
  }

  function handleMouseOver(event: MouseEvent<HTMLDivElement>) {
    const targetElement = event.target as HTMLDivElement;
    if (targetElement.offsetWidth < targetElement.scrollWidth) {
      setTooltipVisible(true);
    }
  }

  function handleMouseOut() {
    setTooltipVisible(false);
  }

  return (
    <div
      data-cy={"button-application-card-swap"}
      className={toogleStyle()}
      style={style}
      onClick={isArchive === undefined ? onClick : undefined}
    >
      <div className={classes.titleWrapper}>
        <UI_ITOTooltip title={title} isOpen={isTooltipVisible}>
          <div
            className={classes.title}
            id="title"
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
          >
            {title}
          </div>
        </UI_ITOTooltip>
        {textDown && <div id="description">{textDown}</div>}
        {status && (
          <Tag className={classes.tag} color={status?.color}>
            {status?.title}
          </Tag>
        )}
      </div>
      <div className={classes.iconWrapper}>
        {iconAdditional}

        {isArchive !== undefined ? (
          <EyeInvisibleOutlined onClick={onClick} />
        ) : (
          <>{icon ? <div>{icon}</div> : <ArrowRightOutlined />}</>
        )}
      </div>
    </div>
  );
}
